module.exports = __webpack_public_path__ + "img/info.d5331825.jpg";